import { render, staticRenderFns } from "./HistoricalData.vue?vue&type=template&id=71426165&scoped=true&"
import script from "./HistoricalData.vue?vue&type=script&lang=js&"
export * from "./HistoricalData.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalData.vue?vue&type=style&index=0&id=71426165&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71426165",
  null
  
)

export default component.exports